import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["isMultiple", "allowNone", "isReadonly", "allowClear", "placeholder", "emptyMessage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { UserOutlined } from '@ant-design/icons';
import { Select, Space, Tag, Tooltip } from 'antd';
import Avatar from 'antd/lib/avatar/avatar';
import { getMediaStore } from 'core/modules/media/media.store';
import { getUserStore } from 'core/modules/users/user.store';
import styled from 'styled-components';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select users. */
export var UserSelect = function UserSelect(_ref) {
  var isMultiple = _ref.isMultiple,
      allowNone = _ref.allowNone,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      placeholder = _ref.placeholder,
      emptyMessage = _ref.emptyMessage,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getUserStore = getUserStore(),
      users = _getUserStore.users,
      getUserById = _getUserStore.getUserById;

  var _getMediaStore = getMediaStore(),
      getUserMediaSrc = _getMediaStore.getUserMediaSrc;

  return /*#__PURE__*/_jsxs(Container, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return sanitizeAll(option.title).includes(sanitizeAll(input));
    },
    placeholder: isReadonly ? emptyMessage : placeholder,
    tagRender: function tagRender(item) {
      if (item.value === 'unassigned') {
        return /*#__PURE__*/_jsx(Tag, {
          children: emptyMessage
        });
      }

      var user = getUserById(item.value);

      if (!user) {
        return /*#__PURE__*/_jsx(_Fragment, {});
      }

      return /*#__PURE__*/_jsx(Tooltip, {
        title: user.name,
        children: /*#__PURE__*/_jsx(Avatar, {
          className: "tag",
          size: 20,
          src: getUserMediaSrc(user.id),
          icon: /*#__PURE__*/_jsx(UserOutlined, {})
        })
      });
    },
    children: [allowNone && /*#__PURE__*/_jsx(Select.Option, {
      value: "unassigned",
      title: emptyMessage,
      children: emptyMessage
    }, "unassigned"), users.map(function (user) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: user.id,
        title: "".concat(user.name, " ").concat(user.email),
        children: /*#__PURE__*/_jsxs(OptionContent, {
          size: "small",
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(Avatar, {
              size: 20,
              src: getUserMediaSrc(user.id),
              icon: /*#__PURE__*/_jsx(UserOutlined, {})
            })
          }), /*#__PURE__*/_jsx("span", {
            children: user.name
          })]
        })
      }, user.id);
    })]
  }));
}; // Styles

var Container = styled(Select).withConfig({
  displayName: "UserSelect__Container",
  componentId: "sc-1yuazqw-0"
})([".tag{margin-right:6px;}"]);
var OptionContent = styled(Space).withConfig({
  displayName: "UserSelect__OptionContent",
  componentId: "sc-1yuazqw-1"
})([""]);